import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { integrationApi, type ProviderHealthStatus } from '../../api/integration';

export function ConnectorHealthPage() {
  const [health, setHealth] = useState<ProviderHealthStatus[]>([]);

  useEffect(() => {
    void integrationApi.health((getWorkspaceId() ?? '')).then(setHealth);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Connector Health</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Real-time connector health, latency and error rates.</p>
      <Link to="/integrations" className="mt-2 inline-block text-sm text-teal-700 hover:underline dark:text-teal-400">← Integration Hub</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {health.map((h) => (
          <div key={h.connector_id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <div className="flex justify-between">
              <span className="font-medium capitalize">{h.provider}</span>
              <span className={`text-sm ${h.state === 'healthy' ? 'text-green-600' : 'text-amber-600'}`}>{h.state}</span>
            </div>
            <p className="mt-2 text-sm text-slate-500">Latency: {h.latency_ms?.toFixed(0) ?? '—'} ms · Error rate: {((h.error_rate ?? 0) * 100).toFixed(1)}%</p>
          </div>
        ))}
        {health.length === 0 && <p className="text-sm text-slate-500">No connectors configured yet.</p>}
      </div>
    </div>
  );
}
